import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import LibraryDraftsGrid from './LibraryDraftsGrid';

const LibraryDraftsGridBridge = react2angular(LibraryDraftsGrid, []);

export default LibraryDraftsGridBridge;
